import React from "react"
import { UploadFileModalStep, FileTypes } from "./UploadFile"
import { Progress } from "../../views/modal/Progress"
import FileCategories from "../../../utils/FileCategories"
import { useReimbursementContext } from "../../context/reimbursement/GetReimbursedContext"
import { FormattedMessage, useIntl } from "react-intl"
import { Box, DialogContentText, DialogTitle } from "@carrotfertility/carotene-core"
import { useStateMachine } from "../../context/stateMachine/StateMachineV2"
import Settings from "../../../utils/CarrotConfig"

export const UploadMedicareAuStatement = (): JSX.Element => {
  const intl = useIntl()
  const fileCategory = FileCategories.MEDICARE_AU_STATEMENT
  const { updateStatementFiles, state } = useReimbursementContext()
  const { send } = useStateMachine()
  const maxFileSize = Settings.MAX_FILE_SIZE / 1000000

  const UploadStatementBody = () => {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: (theme) => theme.tokens.spacing.lg }}>
        <DialogContentText>
          <FormattedMessage
            defaultMessage="If you haven’t already, please upload a copy of the official Medicare Claims History from
            the Australian Government. This document shows the total cost of services as well as the rebate paid by the
            government."
          />
        </DialogContentText>
        <DialogContentText>
          <FormattedMessage
            defaultMessage="We can accept jpg, jpeg, png, pdf, HEIC, doc, docx, txt, xlsx, and zip files up to {maxFileSize} MB."
            values={{ maxFileSize }}
          />
        </DialogContentText>
      </Box>
    )
  }

  const UploadStatementHeader = () => {
    return (
      <DialogTitle>
        <FormattedMessage defaultMessage="Upload your Medicare statement." />
      </DialogTitle>
    )
  }

  const handleContinueClick = (attachments: FileTypes): void => {
    updateStatementFiles(attachments)
    send("")
  }

  return (
    <>
      <Progress
        numSteps={3}
        step={1}
        label={intl.formatMessage({ defaultMessage: "Upload Medicare Statement" })}
        inactiveStepBackgroundColor="#DBE6EE"
      />
      <UploadFileModalStep
        fileCategory={fileCategory}
        header={<UploadStatementHeader />}
        body={<UploadStatementBody />}
        onContinueClick={handleContinueClick}
        files={state.statementFiles}
        useArrowButton
      />
    </>
  )
}
